import { CssBaseline, GlobalStyles, ThemeProvider } from '@mui/material';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { ColorModeContext, useMode } from './theme';
import { FullPageLoader } from './components/FullPageLoader';
import type { RouterContext } from './types/route.types';
import AuthProvider from './libs/auth/AuthProvider';
import { getKeycloak } from './libs/auth/keycloakInstance';
import { APP_HEADER_HEIGHT, APP_HEADER_HEIGHT_VAR } from './components/layouts/appHeader';

const globalStyles = { ':root': { [APP_HEADER_HEIGHT_VAR]: `${APP_HEADER_HEIGHT}px` } };

export const App = () => {
    const [theme, colorMode] = useMode();

    return (
        <>
            <ColorModeContext.Provider value={colorMode}>
                <ThemeProvider theme={theme}>
                    <CssBaseline />
                    <GlobalStyles styles={globalStyles} />
                    <AuthProvider keycloakClient={getKeycloak()}>
                        <Outlet />
                    </AuthProvider>
                </ThemeProvider>
            </ColorModeContext.Provider>
            { import.meta.env.DEV && <TanStackRouterDevtools /> }
        </>
    );
}

export const rootRoute = createRootRouteWithContext<RouterContext>()({
    pendingComponent:  () => <FullPageLoader />,
    component: App,
});